import Layout from "../../layout/Layout"
import SEO from "../../global/Components/SEO/SEO"
import Breadcrumbs from "../../global/Components/Breadcrumb/Breadcrumb"
import parse from'html-react-parser'
import { Row, Col, Spinner } from "reactstrap"
import styles from './Page.module.scss'
import { useEffect, useState } from "react"
import { getRequest } from "../../global/utils/apiCall"
import { useParams } from "react-router-dom"

const PAGE_URL = 'api/v1/pages/';

export default function Page() {
    const {id} = useParams();

    const [isLoading, setIsLoading] = useState(false);
    const [content, setContent] = useState();

    const getPageData = async () => {
        setIsLoading(true);

        try {
            const response = await getRequest(`${PAGE_URL}${id}`)
            setContent(response.data.data);
            setIsLoading(false);
        }
        catch (error){
            console.log(error);
        }
    }

    useEffect(() => {
        getPageData();
    }, [])

  return (
    <>
    <SEO title={content && content.title && content.title} description={content && content.description && content.description} tags={content && content.tags && content.tags}/>
        <Layout>
            <div className={`${styles.pageCover}`}>
                <div className={`${styles.lgtOverlay}`}></div>
                <div className={`container-xxl`}>
                    <div className={`${styles.pageContent} ${styles.pageContentMin} position-relative py-4 d-flex align-items-center`}>
                        <h2 className='text-white fw-bold'>
                            <span>
                                {  
                                    !isLoading && content &&
                                        content.title
                                }
                            </span>
                        </h2>
                    </div>

                </div>
            </div>
            <div className={`container-xxl`}>
                <div className={`p-2 p-sm-4 ${styles.about}`} >
                    {/* <Row>
                        <Col>
                            <Breadcrumbs />
                        </Col>
                    </Row> */}
                    <Row>
                        <Col sm={12} md={12} className='mb-3'>
                           {
                            isLoading
                                ? <div className='text-center'>
                                    <Spinner color='primary'>
                                        Loading...
                                    </Spinner>
                                </div> 
                                : <div className={`${styles.cotent}`}>
                                    {
                                        content &&
                                            parse(content.content)
                                    }
                                </div>
                           }
                        </Col>
                    </Row>
                    <Row>
                        <Col></Col>
                    </Row>
                </div>
            </div>
        </Layout>
    </>

  )
}
